import type { NDateLocale } from './enUS'
import { lv } from 'date-fns/locale'

const dateLvLV: NDateLocale = {
  name: 'lv-LV',
  locale: lv
}

export default dateLvLV
